var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 149,
    viewBox: "0 0 234 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.244 139.536H11.1641V9.97314H224.244V139.536Z",
    fill: "#082C4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44727 1V147.555H232.962V1H2.44727ZM224.245 139.536H11.1648V9.97288H224.245V139.536Z",
    fill: "#F2EAE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.074 108.846L139.745 104.552C146.549 101.703 150.922 100.409 156.185 100.301C167.534 100.063 179.194 106.086 188.357 109.807C195.858 112.846 204.256 112.79 211.715 109.651L222.594 105.075",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4082 83.1186L40.9535 44.9614",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6816 74.2066L35.0054 64.3755",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.371 82.3767L180.658 58.6162",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.043 77.5068L179.258 70.958",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.242 127.629C190.242 127.629 206.917 127.674 208.06 127.497C209.203 127.32 209.556 122.612 211.317 122.525C213.077 122.438 212.85 126.309 212.85 126.309C212.85 126.309 219.14 118.3 221.428 119.665C223.716 121.03 217.778 126.486 217.778 126.486",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.993 127.275C179.803 126.852 179.705 126.394 179.705 125.93C179.705 125.466 179.803 125.008 179.993 124.585C180.04 124.446 180.118 124.321 180.223 124.219C180.328 124.117 180.455 124.041 180.595 123.998C180.988 123.935 181.305 124.318 181.482 124.674C181.876 125.486 182.035 126.392 181.938 127.289C182.045 125.144 182.846 123.093 184.221 121.445C184.57 121.03 185.013 120.613 185.559 120.626C186.106 120.639 186.591 121.154 186.731 121.698C186.833 122.26 186.797 122.838 186.626 123.383C186.303 124.707 185.848 125.995 185.266 127.228C185.765 126.602 189.867 124.772 190.482 125.284C191.273 125.945 187.299 127.341 186.686 127.605",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.547 114.062C201.526 114.605 201.444 116.721 201.449 118.529C201.449 121.149 201.465 124.819 201.473 127.442",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.596 115.044C205.074 115.044 207.893 112.223 207.893 108.743C207.893 105.264 205.074 102.443 201.596 102.443C198.118 102.443 195.299 105.264 195.299 108.743C195.299 112.223 198.118 115.044 201.596 115.044Z",
    fill: "#F2EAE2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.682 109.942C201.682 110.228 201.605 112.095 201.547 114.062",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.553 113.871C202.162 112.709 202.63 111.674 203.268 110.528",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.647 110.542C201.647 110.827 201.576 113.132 201.518 115.097",
    stroke: "#092C4E",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232.999 38.6977L232.962 1H58.5586",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.047 147.632H232.963",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.795 132.532C173.795 131.886 173.605 131.255 173.25 130.715C172.895 130.176 172.39 129.753 171.797 129.498V126.672C173.128 126.971 174.317 127.713 175.17 128.779C176.022 129.844 176.487 131.167 176.487 132.532C176.487 133.896 176.022 135.22 175.17 136.285C174.317 137.35 173.128 138.093 171.797 138.392V135.566C172.39 135.311 172.895 134.888 173.25 134.348C173.605 133.809 173.795 133.178 173.795 132.532Z",
    fill: "#FE6571"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.787 135.577L171.806 129.541V135.566L171.787 135.577Z",
    fill: "#FE6571"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.615 144.669H157.266C156.848 144.669 156.433 144.586 156.046 144.426C155.659 144.266 155.308 144.031 155.012 143.735C154.716 143.438 154.481 143.087 154.321 142.7C154.16 142.313 154.078 141.898 154.078 141.479V124.45C154.078 124.251 154.117 124.055 154.193 123.872C154.269 123.688 154.38 123.522 154.52 123.382C154.66 123.241 154.827 123.13 155.01 123.054C155.193 122.978 155.389 122.939 155.588 122.939H170.291C170.489 122.939 170.686 122.978 170.869 123.054C171.052 123.13 171.218 123.241 171.359 123.382C171.499 123.522 171.61 123.688 171.686 123.872C171.762 124.055 171.801 124.251 171.801 124.45V141.482C171.8 142.327 171.464 143.137 170.867 143.735C170.27 144.332 169.46 144.668 168.615 144.669Z",
    fill: "#FE6571"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.807 126.672V139.522",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.266 113.736C160.738 113.884 159.418 115.165 160.165 116.691C160.429 117.254 160.973 117.637 161.374 118.117C162.232 119.136 161.949 120.605 160.5 121.428",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.963 116.108C164.533 116.459 164.211 116.874 164.306 117.452C164.509 118.661 165.243 118.466 165.462 119.467C165.662 120.383 164.876 121.17 164.493 121.495",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M156.188 123.993H169.41",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.49 144.669H174.151",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.893 123.993V130.872",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.943 135.788H162.631V131.851L163.626 130.872H165.948L166.943 131.851V135.788Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.407 56.7913C161.761 56.7913 169.343 49.2048 169.343 39.8463C169.343 30.4879 161.761 22.9014 152.407 22.9014C143.053 22.9014 135.471 30.4879 135.471 39.8463C135.471 49.2048 143.053 56.7913 152.407 56.7913Z",
    fill: "#FFCC00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M161.985 39.7145C163.243 39.7145 164.262 38.6942 164.262 37.4356C164.262 36.177 163.243 35.1567 161.985 35.1567C160.727 35.1567 159.707 36.177 159.707 37.4356C159.707 38.6942 160.727 39.7145 161.985 39.7145Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.917 31.7262C146.208 31.7262 146.444 31.4897 146.444 31.198C146.444 30.9064 146.208 30.6699 145.917 30.6699C145.625 30.6699 145.389 30.9064 145.389 31.198C145.389 31.4897 145.625 31.7262 145.917 31.7262Z",
    fill: "#092C4E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M157.107 50.3878C157.107 50.3878 159.192 51.3516 160.235 49.2866",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.607 46.1841C143.971 46.1841 144.267 45.8885 144.267 45.5239C144.267 45.1593 143.971 44.8638 143.607 44.8638C143.243 44.8638 142.947 45.1593 142.947 45.5239C142.947 45.8885 143.243 46.1841 143.607 46.1841Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5642 65.9885C86.5629 65.9502 86.5532 65.9126 86.5359 65.8784C86.5186 65.8442 86.494 65.8142 86.464 65.7904L83.1015 63.1049C82.9568 62.9317 82.8345 62.7409 82.7373 62.5372C81.4254 60.1619 79.4961 58.1856 77.1536 56.8176C74.811 55.4495 72.1423 54.7406 69.43 54.7658C61.1374 54.7658 54.2489 61.1508 53.9902 69.3791C53.9902 69.4979 53.9902 69.6167 53.9902 69.7356C53.9902 69.7778 53.9902 69.8174 53.9902 69.8597C53.9902 69.9019 53.9902 69.9283 53.9902 69.9627C53.9902 69.997 53.9902 70.0498 53.9902 70.0947C54.02 72.2054 54.4873 74.2871 55.3627 76.2078C55.5877 76.8853 55.9 77.5307 56.2917 78.1275C57.421 79.8014 58.8383 81.2614 60.4776 82.4397C62.7794 84.0347 65.473 84.9705 68.2675 85.1458C71.062 85.3211 73.8513 84.7295 76.3343 83.4346C78.8172 82.1398 80.8995 80.1909 82.3563 77.7986C83.8132 75.4062 84.5892 72.6611 84.6006 69.8597C84.6006 69.7937 84.6006 68.5684 84.5188 67.9663L86.4745 66.1918C86.5033 66.1665 86.5263 66.1352 86.5418 66.1001C86.5573 66.0649 86.565 66.0269 86.5642 65.9885Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.186 111.827L40.6963 92.7197C40.6963 92.7197 12.5589 104.7 2.63253 125.379C-1.36334 133.705 1.81436 144.421 13.9577 145.939C26.101 147.457 41.7467 145.704 41.7467 145.704V138.112L50.7387 129.689L50.1554 116.372L46.186 111.827Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4075 113.229L98.3083 95.6479C98.3083 95.6479 101.504 96.8891 106.366 100.232C112.241 104.272 120.642 111.196 129.922 120.354C131.972 122.376 136.256 125.086 138.183 127.771C139.991 130.293 140.664 132.245 140.898 134.901C141.36 140.148 138.861 144.78 133.279 146.29C121.476 149.493 115.305 140.681 115.305 140.681L103.864 132.387L93.8215 123.993L90.4512 117.784L94.4075 113.229Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3525 70.5381C81.8135 71.8584 78.6543 70.7757 78.6543 70.7757",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.417 96.9134C125.878 94.045 121.553 92.3177 117.012 91.9595C115.065 91.8065 113.106 91.914 111.187 92.279C109.901 92.5616 108.641 92.9575 107.424 93.4621C107.424 93.4621 105.962 92.7385 103.156 92.0625C100.208 91.3495 96.7612 92.1866 96.7612 92.1866L96.1172 95.1336C96.1172 95.1336 98.9571 95.9469 99.8597 96.3324C101.05 96.8421 104.412 98.7988 104.412 98.7988L111.071 103.618L121.214 112.232L129.428 96.916L129.417 96.9134Z",
    fill: "#FE6571"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.927 114.091C122.84 113.958 120.868 109.271 119.95 107.563C119.032 105.854 117.955 103.436 119.127 103.024C120.298 102.612 124.405 106.206 124.405 106.206L125.939 103.401C125.939 103.401 128.346 106.074 129.135 108.788C129.924 111.503 130.272 117.814 129.264 119.786L122.927 114.091Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.514 95.3973C108.514 95.3973 114.674 93.2531 122.13 97.7739",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M107.918 97.246C107.918 97.246 110.185 96.8489 112.141 97.3095",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M113.924 97.4434C113.924 97.4434 117.709 97.8078 119.994 99.3578",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M104.59 98.9148C105.669 97.1721 106.613 95.3491 107.414 93.4619",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M127.11 96.1235L122.811 104.08",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.252 98.3281L124.307 103.815",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.252 109.591C127.252 109.591 121.49 102.49 119.126 103.018C117.856 103.309 118.73 106.306 122.095 111.534",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0903 127.275H91.8052C93.4178 125.852 94.6688 123.248 95.1624 119.989L98.633 97.0158C99.0105 94.5151 98.4272 92.0566 95.8196 92.0566H42.4744C40.165 92.0566 39.2228 94.5151 39.6002 97.0158L43.0709 119.989C43.5644 123.248 44.8154 125.852 46.4254 127.275H46.143C43.7337 127.275 41.423 128.232 39.7194 129.937C38.0157 131.641 37.0586 133.953 37.0586 136.364V139.105C37.0586 141.515 38.0157 143.827 39.7194 145.532C41.423 147.236 43.7337 148.194 46.143 148.194H92.0903C93.2831 148.194 94.4643 147.959 95.5663 147.502C96.6683 147.045 97.6696 146.376 98.513 145.532C99.3563 144.688 100.025 143.686 100.481 142.583C100.938 141.48 101.172 140.298 101.172 139.105V136.364C101.172 135.17 100.938 133.989 100.481 132.886C100.025 131.783 99.3563 130.781 98.513 129.937C97.6696 129.093 96.6683 128.424 95.5663 127.967C94.4643 127.51 93.2831 127.275 92.0903 127.275Z",
    fill: "#3098F3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5454 95.791C109.24 99.8919 120.905 112.881 135.163 124.722C144.102 132.147 141.851 142.528 134.529 145.818C130.462 147.645 122.877 147.117 118.559 143.613C108.762 135.665 100.348 129.913 93.8105 123.993",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9395 128.368C33.2864 123.351 37.7098 120.077 42.4605 115.939",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5845 145.899C37.1695 145.952 28.3939 146.269 19.5259 146.288C-0.738474 146.327 -1.55137 130.491 4.48202 121.582C12.5741 109.614 25.7678 98.9806 40.9569 92.5137",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.704 52.1567L73.7336 54.3485C72.8929 54.6128 72.0112 54.7229 71.1313 54.6733L70.3896 54.631C67.5897 54.3967 64.7794 54.9407 62.2688 56.2029C59.7582 57.4652 57.6448 59.3966 56.1616 61.7843C54.6785 64.172 53.8833 66.9231 53.8637 69.7342C53.844 72.5453 54.6008 75.3073 56.0504 77.7155C64.6413 77.7155 68.9961 75.7191 71.2976 73.6911C70.8137 73.5068 70.372 73.2265 69.999 72.8672C69.626 72.5079 69.3294 72.0769 69.1269 71.6001C68.9244 71.1233 68.8203 70.6105 68.8207 70.0925C68.8211 69.5744 68.9261 69.0618 69.1294 68.5853C69.3326 68.1089 69.63 67.6784 70.0036 67.3197C70.3772 66.961 70.8193 66.6815 71.3035 66.4979C71.7877 66.3143 72.3039 66.2304 72.8213 66.2513C73.3386 66.2722 73.8465 66.3975 74.3143 66.6195C74.5782 63.6884 74.4832 60.282 73.8656 58.8692C74.8932 59.2939 76.0333 59.3618 77.104 59.062C77.7936 58.8452 78.4339 58.4947 78.988 58.0303C79.5422 57.5659 79.9996 56.9968 80.3339 56.3556C80.6682 55.7143 80.8729 55.0135 80.9364 54.293C80.9999 53.5726 80.9209 52.8466 80.704 52.1567Z",
    fill: "#FFCC00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 24.1554L115.534 23.7593",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 21.647L113.304 26.3024",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.979 22.4736L114.739 25.3783",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.543 25.6424L114.544 21.8452",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M210.498 29.0035L215.513 28.6074",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M212.578 26.4951L213.285 31.1506",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.961 27.3218L214.722 30.2265",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M211.521 30.4906L214.525 26.6934",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M195.184 92.7594L200.198 92.3633",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.262 90.251L197.969 94.9064",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.646 91.0771L199.407 93.9818",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.207 94.2465L199.211 90.4492",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7871 42.8458L58.8017 42.4497",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8633 40.3374L56.5706 44.9928",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 41.1641L58.011 44.0688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8086 44.3324L57.8121 40.5352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M210.785 59.0782C207.161 59.0439 198.132 59.1205 194.215 59.0782C194.008 59.0812 193.806 59.01 193.646 58.8773C193.486 58.7447 193.379 58.5593 193.344 58.3547C193.332 58.2576 193.338 58.159 193.363 58.0642C194.334 54.4545 200.035 54.7713 201.067 55.2361C201.613 54.1798 203.297 52.6245 205.907 52.3103C211.933 51.5841 213.405 55.6111 213.405 55.6111C213.405 55.6111 216.243 55.7537 216.44 58.1065C216.48 58.5818 216.177 59.0835 215.696 59.0782H210.785Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4224 21.5837C51.7042 20.678 49.1758 20.1234 46.1037 21.7474C45.2697 20.8417 40.9703 16.7302 34.9342 20.839C33.707 20.068 25.4988 15.3465 19.9906 23.0704C19.3493 22.9885 17.061 22.7852 15.8575 23.9656C15.2399 24.5703 15.0076 25.4285 15.1686 26.519C15.1782 26.582 15.2102 26.6394 15.2587 26.6807C15.3072 26.7219 15.3689 26.7442 15.4326 26.7435H57.5687C57.6158 26.7471 57.6629 26.7365 57.7039 26.7129C57.7449 26.6894 57.7778 26.654 57.7983 26.6115C57.9277 26.1916 56.806 23.6223 53.4224 21.5837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandbook);
export default __webpack_public_path__ + "static/media/Brandbook.54b6cd7575bff6631acceb8300a3ef81.svg";
export { ForwardRef as ReactComponent };